module.exports = __webpack_public_path__ + "static/media/allie02.62eef5f4.jpg";